import { render, staticRenderFns } from "./KoioteSilo1Properties.vue?vue&type=template&id=36532d34&lang=es&"
import script from "./KoioteSilo1Properties.vue?vue&type=script&lang=js&"
export * from "./KoioteSilo1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports